<template>
    <div class="checkout relative">
    <VivaLoader/>
    <HeaderDashboard />
        <main class="checkout-component bg-gray-50 pt-16 md:pt-36 pb-10">
            <div class="mx-auto flex flex-col md:flex-row max-w-7xl mx-auto container">
                <DashboardSidebarMenu isPage="suscripción"/>
                <div class="main-content w-full md:w-4/5 flex flex-col">
                    <section>
                        <div class="max-w-6xl mx-auto px-4" v-if="subscription">
                            <Notification
                            type="success"
                            :title="`Cambios aplicarán a partir de ${getRenewalDate} en tu siguiente renovación`"
                            content="Solo puedes modificar a tus acompañantes hasta 3 meses después de contratar Viva Fan"
                            v-if="false"
                            />

                            <Notification
                            type="error"
                            title="No se puede realizar cambio"
                            content="Alias aperiam facilis soluta labore assumenda in et dicta sit"
                            v-if="false"/>

                            <Notification
                            type="warning"
                            title="No se puede realizar cambio"
                            content="Alias aperiam facilis soluta labore assumenda in et dicta sit"
                            v-if="false"/>

                        </div>
                    </section>
                    <section class="mb-5">
                        <div class="max-w-6xl mx-auto px-4" v-if="subscription">
                            <DashboardTeamCardInformation />
                        </div>
                    </section>

                    <AdjustSubscription />
                </div>
            </div>
        </main>
    <FooterCheckout />
    </div>
</template>

<script>
import HeaderDashboard from "@/components/header/Header.vue"
import FooterCheckout from "@/components/Footer.vue"
import DashboardSidebarMenu from "@/components/dashboard/SidebarMenu.vue"
import AdjustSubscription from "@/components/dashboard/AdjustSubscription.vue"
import Notification from "@/components/notifications/Notification.vue"
import VivaLoader from "@/components/loader/Loader.vue"
import DashboardTeamCardInformation from '@/components/dashboard/TeamCardInformation.vue'
import { computed } from "@vue/reactivity"
import { onMounted } from "@vue/runtime-core"
import { useStore } from "vuex"
import { useRouter } from "vue-router"

export default({
    name: 'Suscripción',
    components: {
        HeaderDashboard,
        FooterCheckout,
        DashboardSidebarMenu,
        AdjustSubscription,
        Notification,
        VivaLoader,
        DashboardTeamCardInformation
    },
    setup(){

        const store = useStore()
        const router = useRouter()
        const subscription = computed(() => {
            return store.state.Checkout.data.userSubscription.data

        })

        const getRenewalDate = computed( () => {
             if( subscription.value ){
                const expire = new Date(subscription.value.subscription.renewalDate )
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return expire.toLocaleDateString('es-ES', options)
             }
        })

        const checkSubscription = () =>{
            if( !subscription.value ){
                router.push({name: 'Home'})
            }
        }
        
        onMounted( async ()=> {
            if( subscription.value ){
                await store.dispatch('getSubscription', { plan: 'vfn' , continue : false} )
                checkSubscription()
            }
        })

        return { subscription, getRenewalDate}
    }
})
</script>

<style scoped>
.section-header {
	@apply text-3xl text-green-400 font-semibold md:font-bold;
}
.box {
    @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
}
h5 {
    @apply md:text-sm text-green-400;
    font-size: 0.75rem;
}
input.form-control, select.form-control{
    @apply font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300 rounded-md pt-7 pb-2 px-4 rounded-xl shadow-sm border text-green-500 outline-none;
}
label > span {
    @apply text-green-500 sm:text-xs;
}
.form-check-radio {
    @apply w-5 h-5 border-2 rounded-full bg-blue-100;
}
.form-radio-wrapper {
    @apply flex content-center items-center pt-5 pb-0 md:py-5 w-full md:w-auto;
}
.disabled {
    @apply opacity-50 cursor-not-allowed
}
</style>